/**
 * Created by Jerker Nord on 2022-03-31.
 */

import {gsap} from "gsap";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {TextureHelper} from "../utils/TextureHelper";
import {Loner} from "../Loner";
import {BLEND_MODES, SCALE_MODES} from "pixi.js";
import {DropShadowFilter, MotionBlurFilter} from "pixi-filters";
import {LonerGameAssets} from "../LonerGameAssets";
import {SYMBOL_NAMES} from "../../core/reel/ReelInterfaces";

export interface ITextureContainer {
    textureName:string,
    container:PIXI.Container,
    extraWidth:number,
    extraHeight:number,
    filters:PIXI.Filter[],
    forceWidth?:number,
    forceHeight?:number,
    scaleMode?:PIXI.SCALE_MODES
}

export class ResourceCreator {

    private static DUCK_NAMES:string[] = [
        "duck_syms/CLIP/CLIP_left", "duck_syms/CLIP/CLIP_left_burn", "duck_syms/CLIP/X_left", "duck_syms/CLIP/X2_left", "duck_syms/CLIP/X3_left",
        "duck_syms/MAX/MAX_left", "duck_syms/MAX/MAX_left_burn", "duck_syms/MAX/X_left", "duck_syms/MAX/X2_left", "duck_syms/MAX/X3_left",
        "duck_syms/MX1/MX1_left", "duck_syms/MX1/MX1_left_burn", "duck_syms/MX1/X_left", "duck_syms/MX1/X2_left", "duck_syms/MX1/X3_left",
        "duck_syms/MX2/MX2_left", "duck_syms/MX2/MX2_left_burn", "duck_syms/MX2/X4_left",
        "duck_syms/brownDucks/M1_left", "duck_syms/brownDucks/M2_left", "duck_syms/brownDucks/M3_left", "duck_syms/brownDucks/M4_left",
        "duck_syms/brownDucks/M5_left", "duck_syms/brownDucks/M1_left_burn", "duck_syms/brownDucks/M2_left_burn", "duck_syms/brownDucks/M3_left_burn",
        "duck_syms/brownDucks/M4_left_burn", "duck_syms/brownDucks/M5_left_burn", "duck_syms/brownDucks/X_left", "duck_syms/brownDucks/X2_left",
        "duck_syms/brownDucks/X3_left",
        "duck_syms/whiteDucks/M1_left", "duck_syms/whiteDucks/M2_left", "duck_syms/whiteDucks/M3_left", "duck_syms/whiteDucks/M4_left",
        "duck_syms/whiteDucks/M5_left", "duck_syms/whiteDucks/M1_left_burn", "duck_syms/whiteDucks/M2_left_burn", "duck_syms/whiteDucks/M3_left_burn",
        "duck_syms/whiteDucks/M4_left_burn", "duck_syms/whiteDucks/M5_left_burn", "duck_syms/whiteDucks/X_left", "duck_syms/whiteDucks/X2_left",
        "duck_syms/whiteDucks/X3_left",
        "duck_syms/yellowDucks/M1_left", "duck_syms/yellowDucks/M2_left", "duck_syms/yellowDucks/M3_left", "duck_syms/yellowDucks/M4_left",
        "duck_syms/yellowDucks/M5_left", "duck_syms/yellowDucks/M1_left_burn", "duck_syms/yellowDucks/M2_left_burn", "duck_syms/yellowDucks/M3_left_burn",
        "duck_syms/yellowDucks/M4_left_burn", "duck_syms/yellowDucks/M5_left_burn", "duck_syms/yellowDucks/X_left", "duck_syms/yellowDucks/X2_left",
        "duck_syms/yellowDucks/X3_left"
    ];

    private static WIN_SYMBOL_NAMES:string[] = ["L1/L1", "L2/L2", "L3/L3", "L4/L4", "L5/L5", "M1/M1", "M2/M2", "M3/M3", "M4/M4", "M5/M5", "S/S",
        "L1/L1_Split_2", "L1/L1_Split_3", "L1/L1_Split_4", "L1/L1_Split_6", "L1/L1_Split_8",
        "L2/L2_Split_2", "L2/L2_Split_3", "L2/L2_Split_4", "L2/L2_Split_6", "L2/L2_Split_8",
        "L3/L3_Split_2", "L3/L3_Split_3", "L3/L3_Split_4", "L3/L3_Split_6", "L3/L3_Split_8",
        "L4/L4_Split_2", "L4/L4_Split_3", "L4/L4_Split_4", "L4/L4_Split_6", "L4/L4_Split_8",
        "L5/L5_Split_2", "L5/L5_Split_3", "L5/L5_Split_4", "L5/L5_Split_6", "L5/L5_Split_8",
        "M1/M1_Split_2", "M1/M1_Split_3", "M1/M1_Split_4", "M1/M1_Split_6", "M1/M1_Split_8",
        "M2/M2_Split_2", "M2/M2_Split_3", "M2/M2_Split_4", "M2/M2_Split_6", "M2/M2_Split_8",
        "M3/M3_Split_2", "M3/M3_Split_3", "M3/M3_Split_4", "M3/M3_Split_6", "M3/M3_Split_8",
        "M4/M4_Split_2", "M4/M4_Split_3", "M4/M4_Split_4", "M4/M4_Split_6", "M4/M4_Split_8",
        "M5/M5_Split_2", "M5/M5_Split_3", "M5/M5_Split_4", "M5/M5_Split_6", "M5/M5_Split_8",
        "S/S_wild",
        "L1/L1_infectious", "L1/L1_Split_2_infectious", "L1/L1_Split_3_infectious", "L1/L1_Split_4_infectious",
        "L2/L2_infectious", "L2/L2_Split_2_infectious", "L2/L2_Split_3_infectious", "L2/L2_Split_4_infectious",
        "L3/L3_infectious", "L3/L3_Split_2_infectious", "L3/L3_Split_3_infectious", "L3/L3_Split_4_infectious",
        "L4/L4_infectious", "L4/L4_Split_2_infectious", "L4/L4_Split_3_infectious", "L4/L4_Split_4_infectious",
        "L5/L5_infectious", "L5/L5_Split_2_infectious", "L5/L5_Split_3_infectious", "L5/L5_Split_4_infectious",
        "M1/M1_infectious", "M1/M1_Split_2_infectious", "M1/M1_Split_3_infectious", "M1/M1_Split_4_infectious",
        "M2/M2_infectious", "M2/M2_Split_2_infectious", "M2/M2_Split_3_infectious", "M2/M2_Split_4_infectious",
        "M3/M3_infectious", "M3/M3_Split_2_infectious", "M3/M3_Split_3_infectious", "M3/M3_Split_4_infectious",
        "M4/M4_infectious", "M4/M4_Split_2_infectious", "M4/M4_Split_3_infectious", "M4/M4_Split_4_infectious",
        "M5/M5_infectious", "M5/M5_Split_2_infectious", "M5/M5_Split_3_infectious", "M5/M5_Split_4_infectious",
        "wild2X2/wild2X2", "wild2X2/2x2_top", "wild2X2/2x2_bot",
        "wild2X2/wild2X2_Split_2", "wild2X2/2x2_top_Split_2", "wild2X2/2x2_bot_Split_2",
        "wild2X2/wild2X2_Split_4", "wild2X2/2x2_top_Split_4", "wild2X2/2x2_bot_Split_4",
        "wild3X3/wild3X3", "wild3X3/3x3_1-3_bot", "wild3X3/3x3_1-3_top", "wild3X3/3x3_2-3_bot", "wild3X3/3x3_2-3_top",
        "wild3X3/wild3X3_Split_2", "wild3X3/3x3_1-3_bot_Split_2", "wild3X3/3x3_1-3_top_Split_2", "wild3X3/3x3_2-3_bot_Split_2", "wild3X3/3x3_2-3_top_Split_2",
        "wild3X3/wild3X3_Split_4", "wild3X3/3x3_1-3_bot_Split_4", "wild3X3/3x3_1-3_top_Split_4", "wild3X3/3x3_2-3_bot_Split_4", "wild3X3/3x3_2-3_top_Split_4"
    ];
    private static BLUR_SYMBOL_NAMES:string[] = ["S/S_wild", "S/S",
        "wild3X3/wild3X3", "wild2X2/wild2X2",
        "L1/L1", "L2/L2", "L3/L3", "L4/L4", "L5/L5", "M1/M1", "M2/M2", "M3/M3", "M4/M4", "M5/M5",
        "L1/L1_Split_2", "L1/L1_Split_3", "L1/L1_Split_4", "L1/L1_Split_6", "L1/L1_Split_8",
        "L2/L2_Split_2", "L2/L2_Split_3", "L2/L2_Split_4", "L2/L2_Split_6", "L2/L2_Split_8",
        "L3/L3_Split_2", "L3/L3_Split_3", "L3/L3_Split_4", "L3/L3_Split_6", "L3/L3_Split_8",
        "L4/L4_Split_2", "L4/L4_Split_3", "L4/L4_Split_4", "L4/L4_Split_6", "L4/L4_Split_8",
        "L5/L5_Split_2", "L5/L5_Split_3", "L5/L5_Split_4", "L5/L5_Split_6", "L5/L5_Split_8",
        "M1/M1_Split_2", "M1/M1_Split_3", "M1/M1_Split_4", "M1/M1_Split_6", "M1/M1_Split_8",
        "M2/M2_Split_2", "M2/M2_Split_3", "M2/M2_Split_4", "M2/M2_Split_6", "M2/M2_Split_8",
        "M3/M3_Split_2", "M3/M3_Split_3", "M3/M3_Split_4", "M3/M3_Split_6", "M3/M3_Split_8",
        "M4/M4_Split_2", "M4/M4_Split_3", "M4/M4_Split_4", "M4/M4_Split_6", "M4/M4_Split_8",
        "M5/M5_Split_2", "M5/M5_Split_3", "M5/M5_Split_4", "M5/M5_Split_6", "M5/M5_Split_8",
        "L1/L1_infectious", "L1/L1_Split_2_infectious", "L1/L1_Split_3_infectious", "L1/L1_Split_4_infectious",
        "L2/L2_infectious", "L2/L2_Split_2_infectious", "L2/L2_Split_3_infectious", "L2/L2_Split_4_infectious",
        "L3/L3_infectious", "L3/L3_Split_2_infectious", "L3/L3_Split_3_infectious", "L3/L3_Split_4_infectious",
        "L4/L4_infectious", "L4/L4_Split_2_infectious", "L4/L4_Split_3_infectious", "L4/L4_Split_4_infectious",
        "L5/L5_infectious", "L5/L5_Split_2_infectious", "L5/L5_Split_3_infectious", "L5/L5_Split_4_infectious",
        "M1/M1_infectious", "M1/M1_Split_2_infectious", "M1/M1_Split_3_infectious", "M1/M1_Split_4_infectious",
        "M2/M2_infectious", "M2/M2_Split_2_infectious", "M2/M2_Split_3_infectious", "M2/M2_Split_4_infectious",
        "M3/M3_infectious", "M3/M3_Split_2_infectious", "M3/M3_Split_3_infectious", "M3/M3_Split_4_infectious",
        "M4/M4_infectious", "M4/M4_Split_2_infectious", "M4/M4_Split_3_infectious", "M4/M4_Split_4_infectious",
        "M5/M5_infectious", "M5/M5_Split_2_infectious", "M5/M5_Split_3_infectious", "M5/M5_Split_4_infectious",
        "S/S_featureTick", "S/S_featureTickTick", "S/S_featureBoom",
        "S/S_featurePin", "S/S_featureThe", "S/S_featureWin",
        "S/S_featureBonus", "S/S_featureDuck",
        "S/M", "S/A", "S/X", "S/noWin", "S/S_featureMaxWin",
        "S/S_xsplit", "S/S_xways"
    ];
    private static BLUR_SYMBOL_EXTRA_HEIGHT:number = 160;
    private static SCATTER_WIN_SYMBOL_NAMES:string[] = ["S_featureBonus", "S_featureBoom", "S_featurePin", "S_featureTick", "S_wild", "S_xsplit", "S_xways"];
    private static TTB:string[] = [LonerGameAssets.TTB_CHURCH_BUILDING_HIGHLIGHT, LonerGameAssets.TTB_SCHOOL_BUILDING_HIGHLIGHT, LonerGameAssets.TTB_OFFICE_BUILDING_HIGHLIGHT, LonerGameAssets.TTB_CAR, LonerGameAssets.TTB_CHURCH_BUILDING, LonerGameAssets.TTB_SCHOOL_BUILDING, LonerGameAssets.TTB_OFFICE_BUILDING, LonerGameAssets.TTB_LONER_HOUSE];
    private static winSymShadowFilter:DropShadowFilter = new DropShadowFilter({
        alpha : 0.8,
        blur : 3,
        color : 0x000000,
        distance : 10,
        rotation : 45
    });
    private static verticalSpinBlurFilter:MotionBlurFilter = new MotionBlurFilter([0, 55], 40, 0);
    private static maskBlurFilter:MotionBlurFilter = new MotionBlurFilter([0, 200], 300, 0);
    private static textureContainers:ITextureContainer[] = [];

    public static createResources():Promise<NolimitPlugin> {
        return new Promise<any>((resolve, reject) => {

            this.createBackground();
            this.createSymbolWinTextures();
            this.createScatterSymbolWinTextures();
            this.createTTBTextures();
            this.createSpinSymbolTextures();
            this.createMirrorDuckTextures();

            //We need to add some small delays not to choke up the browser
            const batchSize:number = 20;
            let delay:number = 0;
            const createCalls:gsap.core.Timeline = gsap.timeline({paused : true});
            const destroyCalls:gsap.core.Timeline = gsap.timeline({paused : true});
            while(ResourceCreator.textureContainers.length > 0) {
                delay += 0.01;
                let batch:ITextureContainer[] = [];
                if(ResourceCreator.textureContainers.length < batchSize) {
                    batch = ResourceCreator.textureContainers.splice(-ResourceCreator.textureContainers.length, ResourceCreator.textureContainers.length);
                } else {
                    batch = ResourceCreator.textureContainers.splice(-batchSize, batchSize);
                }

                createCalls.add(() => ResourceCreator.addBatchTextureContainersAsTextures(batch), delay);
                destroyCalls.add(() => ResourceCreator.addBatchDestroy(batch), delay);
            }

            const tl:gsap.core.Timeline = gsap.timeline({
                paused : true, onComplete : () => {
                    resolve(true);
                }
            });

            tl.add(createCalls.play(0));
            tl.add(destroyCalls.play(0));
            tl.play(0);
        });
    }

    private static createBackground():void{
        const bgContainer:PIXI.Container = new PIXI.Container();
        const bgLeft:PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("bgLeft")[0]);
        const bgRight:PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("bgRight")[0]);
        const bgTop:PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("bgTop")[0]);
        const bgBottom:PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("bgBottom")[0]);
        const bgCenter:PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("bgCenter")[0]);
        bgContainer.addChild(bgLeft);
        bgTop.position.x = bgLeft.width;
        bgContainer.addChild(bgTop);
        bgBottom.position.x = bgLeft.width;
        bgBottom.position.y = bgLeft.height - bgBottom.height;
        bgContainer.addChild(bgBottom);
        bgRight.position.x = (bgLeft.width + bgTop.width);
        bgContainer.addChild(bgRight);
        bgCenter.position.x = bgLeft.width;
        bgCenter.position.y = bgTop.height;
        bgContainer.addChild(bgCenter);

        PIXI.Texture.addToCache(TextureHelper.createRenderedTextureFromContainer(bgContainer), "bg");

        bgContainer.destroy({children : true});
    }

    private static createSpinSymbolTextures():void {
        for(let i:number = 0; i < ResourceCreator.BLUR_SYMBOL_NAMES.length; i++) {
            const container01:PIXI.Container = new PIXI.Container();
            const symbolTexture:PIXI.Texture = Loner.assetLoader.getTextures(ResourceCreator.BLUR_SYMBOL_NAMES[i])[0];
            const symbol:PIXI.Sprite = new PIXI.Sprite(symbolTexture);
            container01.addChild(symbol);

            let name:string = ResourceCreator.BLUR_SYMBOL_NAMES[i];
            const maskSprite:PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("blurSymbolMask")[0]);
            if(name == SYMBOL_NAMES.wild3X3 || name == SYMBOL_NAMES.wild2X2) {
                maskSprite.texture = Loner.assetLoader.getTextures("blurWildSymbolMask")[0];
            }
            container01.mask = maskSprite;
            container01.addChild(maskSprite);
            symbol.height = symbol.height + ResourceCreator.BLUR_SYMBOL_EXTRA_HEIGHT;
            maskSprite.width = symbol.width;
            maskSprite.height = symbol.height;
            container01.alpha = 0.9;


            ResourceCreator.addTextureContainer({
                container : container01,
                textureName : name + "_spin",
                extraWidth : 0,
                extraHeight : 0,
                forceHeight : 0,
                forceWidth : 0,
                filters : [ResourceCreator.verticalSpinBlurFilter]
            })
        }
    }

    private static createMirrorDuckTextures():void {
        for(let i:number = 0; i < ResourceCreator.DUCK_NAMES.length; i++) {
            const container01:PIXI.Container = new PIXI.Container();
            const symbolTexture:PIXI.Texture = Loner.assetLoader.getTextures(ResourceCreator.DUCK_NAMES[i])[0];
            const symbol:PIXI.Sprite = new PIXI.Sprite(symbolTexture);
            symbol.anchor.set(0.5, 0.5);
            symbol.position.x = symbol.width / 2;
            symbol.position.y = symbol.height / 2;
            container01.addChild(symbol);
            symbol.scale.x = -1;
            const newTextureName:string = ResourceCreator.DUCK_NAMES[i].replace("left", "right");

            ResourceCreator.addTextureContainer({
                container : container01,
                textureName : newTextureName,
                extraWidth : 0,
                extraHeight : 0,
                forceHeight : 0,
                forceWidth : 0,
                filters : []
            })
        }
    }

    private static createTTBTextures():void {
        for(let i:number = 0; i < ResourceCreator.TTB.length; i++) {
            const container01:PIXI.Container = new PIXI.Container();
            const symbolTexture:PIXI.Texture = Loner.assetLoader.getTextures(ResourceCreator.TTB[i])[0];
            const symbol:PIXI.Sprite = new PIXI.Sprite(symbolTexture);
            container01.addChild(symbol);

            ResourceCreator.addTextureContainer({
                container : container01,
                textureName : ResourceCreator.TTB[i] + "_pixels",
                extraWidth : 0,
                extraHeight : 0,
                forceHeight : 0,
                forceWidth : 0,
                filters : [],
                scaleMode : SCALE_MODES.NEAREST
            })
        }
    }

    private static createScatterSymbolWinTextures():void {
        for(let i:number = 0; i < ResourceCreator.SCATTER_WIN_SYMBOL_NAMES.length; i++) {
            const container01:PIXI.Container = new PIXI.Container();
            const symbolTexture:PIXI.Texture = Loner.assetLoader.getTextures("S/" + ResourceCreator.SCATTER_WIN_SYMBOL_NAMES[i])[0];
            const symbol:PIXI.Sprite = new PIXI.Sprite(symbolTexture);
            container01.addChild(symbol);

            ResourceCreator.addTextureContainer({
                container : container01,
                textureName : ResourceCreator.SCATTER_WIN_SYMBOL_NAMES[i] + "/" + ResourceCreator.SCATTER_WIN_SYMBOL_NAMES[i] + "_win",
                extraWidth : 0,
                extraHeight : 0,
                forceHeight : container01.height + 20,
                forceWidth : container01.width + 20,
                filters : [this.winSymShadowFilter]
            })

            const container02:PIXI.Container = new PIXI.Container();
            const symbol2:PIXI.Sprite = new PIXI.Sprite(symbolTexture);
            container02.addChild(symbol2);
            const addSymbol:PIXI.Sprite = new PIXI.Sprite(symbolTexture.clone());
            addSymbol.blendMode = BLEND_MODES.ADD;
            container02.addChild(addSymbol);

            ResourceCreator.addTextureContainer({
                container : container02,
                textureName : ResourceCreator.SCATTER_WIN_SYMBOL_NAMES[i] + "/" + ResourceCreator.SCATTER_WIN_SYMBOL_NAMES[i] + "_win_add",
                extraWidth : 0,
                extraHeight : 0,
                forceHeight : container02.height + 20,
                forceWidth : container02.width + 20,
                filters : [this.winSymShadowFilter]
            })
        }
    }

    private static createSymbolWinTextures():void {
        for(let i:number = 0; i < ResourceCreator.WIN_SYMBOL_NAMES.length; i++) {
            const container01:PIXI.Container = new PIXI.Container();
            const symbolTexture:PIXI.Texture = Loner.assetLoader.getTextures(ResourceCreator.WIN_SYMBOL_NAMES[i])[0];
            const symbol:PIXI.Sprite = new PIXI.Sprite(symbolTexture);
            container01.addChild(symbol);

            ResourceCreator.addTextureContainer({
                container : container01,
                textureName : ResourceCreator.WIN_SYMBOL_NAMES[i] + "_win",
                extraWidth : 0,
                extraHeight : 0,
                forceHeight : container01.height + 20,
                forceWidth : container01.width + 20,
                filters : [this.winSymShadowFilter]
            })

            const container02:PIXI.Container = new PIXI.Container();
            const symbol2:PIXI.Sprite = new PIXI.Sprite(symbolTexture);
            container02.addChild(symbol2);
            const addSymbol:PIXI.Sprite = new PIXI.Sprite(symbolTexture.clone());
            addSymbol.blendMode = BLEND_MODES.ADD;
            container02.addChild(addSymbol);

            ResourceCreator.addTextureContainer({
                container : container02,
                textureName : ResourceCreator.WIN_SYMBOL_NAMES[i] + "_win_add",
                extraWidth : 0,
                extraHeight : 0,
                forceHeight : container02.height + 20,
                forceWidth : container02.width + 20,
                filters : [this.winSymShadowFilter]
            })
        }
    }

    private static addTextureContainer(textureContainer:ITextureContainer):void {
        ResourceCreator.textureContainers.push(textureContainer);
    }

    private static addBatchTextureContainersAsTextures(batch:ITextureContainer[]):void {
        let containerTexture:PIXI.Texture;
        for(let i:number = 0; i < batch.length; i++) {
            batch[i].container.filters = batch[i].filters;
            containerTexture = TextureHelper.createRenderedTextureFromContainer(batch[i].container, batch[i].extraWidth, 0, 1, batch[i].forceWidth, batch[i].forceHeight, batch[i].scaleMode);
            PIXI.Texture.addToCache(containerTexture, batch[i].textureName);
        }
    }

    private static addBatchDestroy(batch:ITextureContainer[]):void {
        for(let i:number = 0; i < batch.length; i++) {
            batch[i].container.destroy({children : true});
        }
    }
}